import React from 'react';
import { Card, CardBody, Row, Col, Table, Badge } from 'reactstrap';
import { Bar, Doughnut } from 'react-chartjs-2';

const ClientAnalysis = ({ data }) => {
  // Gráfico de clientes por edad
  const ageGroupsData = {
    labels: data?.ageGroups?.map(item => item.range) || [],
    datasets: [
      {
        label: 'Clientes',
        data: data?.ageGroups?.map(item => item.count) || [],
        backgroundColor: 'rgba(44, 168, 255, 0.8)',
        borderColor: '#2CA8FF',
        borderWidth: 1
      }
    ]
  };

  // Gráfico de estado de clientes
  const clientStatusData = {
    labels: ['Activos', 'Inactivos', 'Nuevos', 'En Riesgo'],
    datasets: [
      {
        data: [
          data?.clientStatus?.active || 0,
          data?.clientStatus?.inactive || 0,
          data?.clientStatus?.new || 0,
          data?.clientStatus?.at_risk || 0
        ],
        backgroundColor: [
          'rgba(40, 167, 69, 0.8)',
          'rgba(108, 117, 125, 0.8)',
          'rgba(255, 193, 7, 0.8)',
          'rgba(220, 53, 69, 0.8)'
        ],
        borderColor: [
          '#28a745',
          '#6c757d',
          '#ffc107',
          '#dc3545'
        ],
        borderWidth: 1
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      }
    }
  };

  return (
    <Row className="mb-4">
      {/* Gráfico de grupos de edad */}
      <Col lg="6" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Distribución por Edad</h5>
            <div style={{ height: '300px' }}>
              <Bar data={ageGroupsData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Gráfico de estado de clientes */}
      <Col lg="6" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Estado de Clientes</h5>
            <div style={{ height: '300px' }}>
              <Doughnut data={clientStatusData} options={doughnutOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Top clientes más activos */}
      <Col lg="12" className="mb-4">
        <Card>
          <CardBody>
            <h5 className="card-title mb-3">Top 10 Clientes Más Activos</h5>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Cliente</th>
                  <th>Membresía</th>
                  <th>Clases Tomadas</th>
                  <th>Última Visita</th>
                  <th>Estado</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                {data?.topClients?.map((client, index) => (
                  <tr key={index}>
                    <td>
                      <Badge color="primary">{index + 1}</Badge>
                    </td>
                    <td>
                      <div>
                        <strong>{client.name}</strong>
                        <br />
                        <small className="text-muted">{client.email}</small>
                      </div>
                    </td>
                    <td>
                      <Badge color="info">{client.membership_name}</Badge>
                    </td>
                    <td>
                      <strong>{client.classes_taken}</strong>
                    </td>
                    <td>{client.last_visit}</td>
                    <td>
                      <Badge color={client.status === 'active' ? 'success' : 'warning'}>
                        {client.status === 'active' ? 'Activo' : 'Inactivo'}
                      </Badge>
                    </td>
                    <td>
                      <strong className="text-success">
                        Q {(client.total_value || 0).toFixed(2)}
                      </strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>

      {/* Clientes en riesgo */}
      <Col lg="12" className="mb-4">
        <Card>
          <CardBody>
            <h5 className="card-title mb-3">Clientes en Riesgo de Cancelación</h5>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Membresía</th>
                  <th>Última Visita</th>
                  <th>Días Sin Visitar</th>
                  <th>Clases Restantes</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {data?.clientsAtRisk?.map((client, index) => (
                  <tr key={index}>
                    <td>
                      <div>
                        <strong>{client.name}</strong>
                        <br />
                        <small className="text-muted">{client.email}</small>
                      </div>
                    </td>
                    <td>{client.membership_name}</td>
                    <td>{client.last_visit}</td>
                    <td>
                      <Badge color={client.days_since_visit > 30 ? 'danger' : 'warning'}>
                        {client.days_since_visit} días
                      </Badge>
                    </td>
                    <td>
                      <Badge color="info">{client.remaining_classes}</Badge>
                    </td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary">
                        Contactar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ClientAnalysis;
